import IconX from '@lib/icons/IconX'
import { Button } from '@octopus-do/octopus-storybook'
import type React from 'react'

import type { CrawlerRedirect } from '@/types'
import css from './styles.module.css'

export const crawlRedirectCardClass = css.card

interface Props extends CrawlerRedirect {
  cancelButton: React.ReactNode
  confirmCb: () => void
  onCancel: () => void
}

export const CrawlRedirectDialog: React.FC<Props> = ({
  sourceUrl,
  destinationUrl,
  cancelButton,
  confirmCb,
  onCancel,
}) => (
  <div
    role="dialog"
    aria-modal="true"
    aria-labelledby="crawl-redirect-title"
    onKeyDown={(event) => {
      // Let the focused button handle Enter, including Cancel and Close.
      if (event.key === 'Enter') {
        event.stopPropagation()
      }
    }}
  >
    <button className={css.close} aria-label="Close" onClick={onCancel}>
      <IconX />
    </button>
    <div id="crawl-redirect-title" className="System-dialog__title">
      This website redirects to another domain
    </div>
    <div className="System-dialog__description">
      <p className={css.message}>
        {new URL(sourceUrl).hostname} redirects to{' '}
        {new URL(destinationUrl).hostname}. Crawl the website on the new domain?
      </p>
    </div>
    <div className={css.buttons}>
      <Button size="medium" label="Crawl" autoFocus onClick={confirmCb} />
      <div className="System-dialog__buttons-item">{cancelButton}</div>
    </div>
  </div>
)
